namespace AgerLMS.LMS {
    export interface GetCartResponse extends Serenity.ServiceResponse {
        CartProducts?: WebSite.CartProduct[];
        DiscountId?: number;
        DiscountAmount?: number;
        Discount?: DiscountsRow;
    }
}
